/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React from 'react';
import CommonProgressBar from '../../../../shared/CommonProgressBar/CommonProgressBar';
import {
  getConvertedUnit,
  getNullConverted
} from '../../../../shared/Utils/EnergyUsagesViewDetailsUtils';
import { ConversionType, getConvertedValue } from '../../../../../main';

interface IEnergyActual {
  value: number | null | string;
  unit: string;
  savings: number;
  savingsPercentage: number;
  progessBarRelativeWidth: number;
  absoluteActual: number;
  absolutePrevPeriod: number | null;
  energyMeasurementUnit?: string;
  sourceType?: string;
}

const EnergyActualConsumptionComponent = (props: IEnergyActual) => {
  const {
    value,
    unit,
    savings,
    savingsPercentage,
    progessBarRelativeWidth,
    absoluteActual,
    absolutePrevPeriod,
    energyMeasurementUnit
  } = props;
  const progressBarProps = {
    actual: absoluteActual,
    previousPeriod: absolutePrevPeriod,
    savings,
    savingsPercentage,
    progessBarRelativeWidth
  };
  return value === null ? (
    <>--</>
  ) : (
    <span className="score-category-meterdata">
      <span className="score-category-percent">
        <div className="measurementunit">
          {getNullConverted(
            getConvertedValue(
              props.sourceType ? props.sourceType : ConversionType.ELECTRICITY,
              energyMeasurementUnit ? energyMeasurementUnit : 'kilowatt hour',
              Number(value),
              unit
            ).Value
          )}
          {/* {getNullConverted(value as number)} */}
        </div>
        {getConvertedUnit(value as number, unit)}
      </span>
      <span className="score-category-progress">
        <CommonProgressBar {...progressBarProps} />
      </span>
    </span>
  );
};

export default EnergyActualConsumptionComponent;
